import { cn as M } from "../../../lib/utils.es.js";
import { buttonVariants as $ } from "../button/Button.variants.es.js";
import { Input as oe } from "../input/Input.es.js";
import { UiSelect as j, UiSelectContent as X, UiSelectItem as U, UiSelectTrigger as G, UiSelectValue as K } from "../select/Select.es.js";
import { UiPopover as se, UiPopoverContent as ae, UiPopoverContentNonPortal as ce, UiPopoverTrigger as ue } from "../popover/Popover.es.js";
import { Fragment as q, jsx as n, jsxs as w } from "react/jsx-runtime";
import { Calendar as be, ChevronLeft as de, ChevronRight as fe, Clock as me } from "lucide-react";
import * as m from "react";
import { useImperativeHandle as Z, useRef as ge } from "react";
import { DayPicker as he } from "react-day-picker";
import I from "dayjs";
import { add as pe, format as J } from "date-fns";
import { ru as E } from "date-fns/locale";
var Ne = /^(0[0-9]|1[0-9]|2[0-3])$/, ve = /^(0[1-9]|1[0-2])$/, we = /^[0-5][0-9]$/, k = 10, Se = 2, ye = "0", f = 0, _e = 23, Me = 1, He = 12, Re = 59, _ = 12, Pe = 11, xe = 22, Te = 9, Ae = 12, De = 90, Ue = 2e3, Ie = 1, Ee = -1, B = 24, ke = 12, Ce = 1e3, Oe = 60, Ve = 60, Ye = 24;
function Fe(e) {
  return Ne.test(e);
}
function Le(e) {
  return ve.test(e);
}
function $e(e) {
  return we.test(e);
}
function O(e, { max: t, min: r = f, loop: l = !1 }) {
  let i = Number.parseInt(e, k);
  return Number.isNaN(i) ? "00" : (l ? (i > t && (i = r), i < r && (i = t)) : (i > t && (i = t), i < r && (i = r)), i.toString().padStart(Se, ye));
}
function ee(e) {
  return Fe(e) ? e : O(e, { max: _e });
}
function te(e) {
  return Le(e) ? e : O(e, {
    min: Me,
    max: He
  });
}
function C(e) {
  return $e(e) ? e : O(e, { max: Re });
}
function z(e, { min: t, max: r, step: l }) {
  let i = Number.parseInt(e, k);
  return Number.isNaN(i) ? "00" : (i += l, O(String(i), {
    min: t,
    max: r,
    loop: !0
  }));
}
function je(e, t) {
  return z(e, {
    min: 0,
    max: 23,
    step: t
  });
}
function Xe(e, t) {
  return z(e, {
    min: 1,
    max: 12,
    step: t
  });
}
function Q(e, t) {
  return z(e, {
    min: 0,
    max: 59,
    step: t
  });
}
function Ge(e, t) {
  const r = C(t);
  return e.setMinutes(Number.parseInt(r, 10)), e;
}
function Ke(e, t) {
  const r = C(t);
  return e.setSeconds(Number.parseInt(r, 10)), e;
}
function Be(e, t) {
  const r = ee(t);
  return e.setHours(Number.parseInt(r, 10)), e;
}
function We(e, t, r) {
  const l = Je(Number.parseInt(te(t), 10), r);
  return e.setHours(l), e;
}
function W(e, t, r, l) {
  switch (r) {
    case "minutes":
      return Ge(e, t);
    case "seconds":
      return Ke(e, t);
    case "hours":
      return Be(e, t);
    case "12hours":
      return l ? We(e, t, l) : e;
    default:
      return e;
  }
}
function ze(e, t) {
  if (!e) return "00";
  switch (t) {
    case "minutes":
      return C(String(e.getMinutes()));
    case "seconds":
      return C(String(e.getSeconds()));
    case "hours":
      return ee(String(e.getHours()));
    case "12hours":
      return te(String(re(e.getHours())));
    default:
      return "00";
  }
}
function qe(e, t, r) {
  switch (r) {
    case "minutes":
      return Q(e, t);
    case "seconds":
      return Q(e, t);
    case "hours":
      return je(e, t);
    case "12hours":
      return Xe(e, t);
    default:
      return "00";
  }
}
function Je(e, t) {
  return t === "PM" ? e <= Pe ? e + _ : e : t === "AM" && e === _ ? f : e;
}
function re(e) {
  return e === f || e === _ ? "12" : e >= xe ? `${e - _}` : e % _ > Te ? `${e}` : `0${e % _}`;
}
function Qe(e) {
  return Array.from({ length: Ae }, (t, r) => ({
    value: r,
    label: e.localize?.month(r, {
      width: "wide",
      context: "standalone"
    }) ?? r.toString()
  }));
}
function Ze(e, t) {
  const r = I(e).year(), l = I(t).year();
  return r > l ? (console.warn(`genYears: начальный год (${r}) больше конечного (${l}).`), []) : Array.from({ length: l - r + 1 }, (i, u) => {
    const b = r + u;
    return {
      value: b,
      label: b.toString()
    };
  });
}
function ie({ className: e, classNames: t, showOutsideDays: r = !0, minDate: l = I().subtract(De, "year").startOf("day").toDate(), maxDate: i = I().endOf("day").toDate(), locale: u, month: b, ...d }) {
  const g = m.useMemo(() => Qe(E), [u]), a = m.useMemo(() => Ze(l, i), [l, i]), p = () => b ? b.getFullYear() === l.getFullYear() && b.getMonth() === l.getMonth() : !1, N = () => b ? b.getFullYear() === i.getFullYear() && b.getMonth() === i.getMonth() : !1;
  return /* @__PURE__ */ n(he, {
    className: M("lib:p-3", e),
    classNames: {
      months: "lib:flex lib:flex-col lib:sm:flex-row lib:space-y-4 lib:sm:space-y-0 lib:justify-center",
      month: "lib:flex lib:flex-col lib:items-center lib:space-y-4",
      month_caption: "lib:flex lib:justify-center lib:pt-1 lib:relative lib:items-center",
      caption_label: "lib:text-sm lib:font-normal",
      nav: "lib:space-x-1 lib:flex lib:items-center ",
      button_previous: M($({ variant: "outlineDark" }), "lib:absolute lib:top-5 lib:left-5 lib:h-7! lib:w-7 lib:bg-transparent lib:p-0! lib:opacity-50 lib:hover:opacity-100", p() && "lib:pointer-events-none"),
      button_next: M($({ variant: "outlineDark" }), "lib:absolute lib:top-5 lib:right-5 lib:h-7! lib:w-7 lib:bg-transparent lib:p-0! lib:opacity-50 lib:hover:opacity-100", N() && "lib:pointer-events-none"),
      month_grid: "lib:w-full lib:border-collapse lib:space-y-1",
      weekdays: M("lib:flex", d.showWeekNumber && "lib:justify-end"),
      weekday: "lib:text-muted-foreground lib:rounded-md lib:w-9 lib:font-normal lib:text-[0.8rem]",
      week: "lib:flex lib:w-full lib:mt-2",
      day: "lib:h-9 lib:w-9 lib:text-center lib:text-sm lib:p-0 lib:relative lib:[&:has([aria-selected].day-range-end)]:rounded-r-md lib:[&:has([aria-selected].day-outside)]:bg-accent/50 lib:[&:has([aria-selected])]:bg-accent lib:first:[&:has([aria-selected])]:rounded-l-md lib:last:[&:has([aria-selected])]:rounded-r-md lib:focus-within:relative lib:focus-within:z-20 lib:rounded-sm",
      day_button: M($({ variant: "ghostDark" }), "lib:h-9! lib:w-9 lib:rounded-r-md lib:rounded-l-md lib:p-0! lib:font-normal lib:aria-selected:opacity-100"),
      range_end: "day-range-end",
      selected: "lib:bg-primary lib:text-white lib:hover:bg-primary lib:hover:text-white lib:focus:bg-primary lib:focus:text-white lib:rounded-l-md lib:rounded-r-md",
      today: "lib:bg-accent lib:text-accent-foreground",
      outside: "lib:day-outside lib:text-muted-foreground lib:opacity-50 lib:aria-selected:bg-accent/50 lib:aria-selected:text-muted-foreground lib:aria-selected:opacity-30",
      disabled: "lib:text-muted-foreground lib:opacity-50",
      range_middle: "lib:aria-selected:bg-accent lib:aria-selected:text-accent-foreground",
      hidden: "invisible",
      ...t
    },
    components: {
      Chevron: ({ ...v }) => v.orientation === "left" ? /* @__PURE__ */ n(de, { className: "lib:h-4 lib:w-4" }) : /* @__PURE__ */ n(fe, { className: "lib:h-4 lib:w-4" }),
      MonthCaption: ({ calendarMonth: v }) => {
        const R = v.date.getMonth().toString(), P = v.date.getFullYear().toString();
        return /* @__PURE__ */ w("div", {
          className: "lib:inline-flex lib:gap-2",
          children: [/* @__PURE__ */ w(j, {
            defaultValue: R,
            onValueChange: (o) => {
              const h = new Date(v.date);
              h.setMonth(Number.parseInt(o, k)), d.onMonthChange?.(h);
            },
            children: [/* @__PURE__ */ n(G, {
              className: "lib:w-fit lib:gap-1 lib:rounded-sm lib:border lib:border-transparent lib:px-1 lib:pl-1 lib:shadow-none lib:transition-colors lib:focus:border-dark-20",
              children: /* @__PURE__ */ n(K, {})
            }), /* @__PURE__ */ n(X, { children: g.map((o) => /* @__PURE__ */ n(U, {
              value: o.value.toString(),
              children: o.label
            }, o.value)) })]
          }), /* @__PURE__ */ w(j, {
            onValueChange: (o) => {
              const h = new Date(v.date);
              h.setFullYear(Number.parseInt(o, k)), d.onMonthChange?.(h);
            },
            value: P,
            children: [/* @__PURE__ */ n(G, {
              className: "lib:w-fit lib:gap-1 lib:rounded-sm lib:border lib:border-transparent lib:pl-1 lib:shadow-none lib:transition-colors lib:focus:border-dark-20",
              children: /* @__PURE__ */ n(K, {})
            }), /* @__PURE__ */ n(X, { children: a.map((o) => /* @__PURE__ */ n(U, {
              value: o.value.toString(),
              children: o.label
            }, o.value)) })]
          })]
        });
      }
    },
    disabled: { after: i },
    endMonth: i,
    locale: E,
    month: "selected" in d && d.selected instanceof Date ? d.selected : void 0,
    showOutsideDays: r,
    startMonth: l,
    ...d
  });
}
ie.displayName = "Calendar";
var ne = m.forwardRef(({ period: e, setPeriod: t, date: r, onDateChange: l, onLeftFocus: i, onRightFocus: u }, b) => {
  const d = (a) => {
    a.key === "ArrowRight" && u?.(), a.key === "ArrowLeft" && i?.();
  }, g = (a) => {
    if (t?.(a), r) {
      const p = new Date(r), N = re(r.getHours());
      l?.(W(p, N.toString(), "12hours", e === "AM" ? "PM" : "AM"));
    }
  };
  return /* @__PURE__ */ n("div", {
    className: "lib:flex lib:h-10 lib:items-center",
    children: /* @__PURE__ */ w(j, {
      defaultValue: e,
      onValueChange: (a) => g(a),
      children: [/* @__PURE__ */ n(G, {
        className: "lib:w-[65px] lib:focus:bg-accent lib:focus:text-accent-foreground",
        onKeyDown: d,
        ref: b,
        children: /* @__PURE__ */ n(K, {})
      }), /* @__PURE__ */ w(X, { children: [/* @__PURE__ */ n(U, {
        value: "AM",
        children: "AM"
      }), /* @__PURE__ */ n(U, {
        value: "PM",
        children: "PM"
      })] })]
    })
  });
});
ne.displayName = "TimePeriodSelect";
var D = m.forwardRef(({ className: e, type: t = "tel", value: r, id: l, name: i, date: u = new Date((/* @__PURE__ */ new Date()).setHours(f, f, f, f)), onDateChange: b, onChange: d, onKeyDown: g, picker: a, period: p, onLeftFocus: N, onRightFocus: v, ...R }, P) => {
  const [o, h] = m.useState(!1), [T, S] = m.useState("0");
  m.useEffect(() => {
    if (o) {
      const s = setTimeout(() => {
        h(!1);
      }, Ue);
      return () => clearTimeout(s);
    }
  }, [o]);
  const y = m.useMemo(() => ze(u, a), [u, a]), V = (s) => a === "12hours" && o && y.slice(1, 2) === "1" && T === "0" ? `0${s}` : o ? y.slice(1, 2) + s : `0${s}`, Y = (s) => {
    if (s.key !== "Tab") {
      if (s.preventDefault(), s.key === "ArrowRight" && v?.(), s.key === "ArrowLeft" && N?.(), ["ArrowUp", "ArrowDown"].includes(s.key)) {
        const H = qe(y, s.key === "ArrowUp" ? Ie : Ee, a);
        o && h(!1);
        const x = u ? new Date(u) : /* @__PURE__ */ new Date();
        b?.(W(x, H, a, p));
      }
      if (s.key >= "0" && s.key <= "9") {
        a === "12hours" && S(s.key);
        const H = V(s.key);
        o && v?.(), h((F) => !F);
        const x = u ? new Date(u) : /* @__PURE__ */ new Date();
        b?.(W(x, H, a, p));
      }
    }
  };
  return /* @__PURE__ */ n(oe, {
    className: M("lib:w-[3rem] lib:min-w-auto lib:text-center lib:font-mono lib:text-base lib:tabular-nums lib:caret-transparent lib:focus:bg-accent lib:focus:text-accent-foreground lib:[&::-webkit-inner-spin-button]:appearance-none", e),
    id: l ?? a,
    inputMode: "decimal",
    name: i ?? a,
    onChange: (s) => {
      s.preventDefault(), d?.(s);
    },
    onKeyDown: (s) => {
      g?.(s), Y(s);
    },
    ref: P,
    type: t,
    value: r || y,
    ...R
  });
});
D.displayName = "TimePickerInput";
var le = m.forwardRef(({ date: e, onChange: t, hourCycle: r = B, granularity: l = "second" }, i) => {
  const u = m.useRef(null), b = m.useRef(null), d = m.useRef(null), g = m.useRef(null), [a, p] = m.useState(e && e.getHours() >= _ ? "PM" : "AM");
  return Z(i, () => ({
    minuteRef: u.current,
    hourRef: b.current,
    secondRef: d.current,
    periodRef: g.current
  }), [
    u,
    b,
    d
  ]), /* @__PURE__ */ w("div", {
    className: "lib:flex lib:items-center lib:justify-center lib:gap-2",
    children: [
      /* @__PURE__ */ n("label", {
        className: "lib:cursor-pointer",
        htmlFor: "datetime-picker-hour-input",
        children: /* @__PURE__ */ n(me, { className: "lib:mr-2 lib:h-4 lib:w-4" })
      }),
      /* @__PURE__ */ n(D, {
        date: e,
        id: "datetime-picker-hour-input",
        onDateChange: t,
        onRightFocus: () => u?.current?.focus(),
        period: a,
        picker: r === B ? "hours" : "12hours",
        ref: b
      }),
      (l === "minute" || l === "second") && /* @__PURE__ */ w(q, { children: [":", /* @__PURE__ */ n(D, {
        date: e,
        onDateChange: t,
        onLeftFocus: () => b?.current?.focus(),
        onRightFocus: () => d?.current?.focus(),
        picker: "minutes",
        ref: u
      })] }),
      l === "second" && /* @__PURE__ */ w(q, { children: [":", /* @__PURE__ */ n(D, {
        date: e,
        onDateChange: t,
        onLeftFocus: () => u?.current?.focus(),
        onRightFocus: () => g?.current?.focus(),
        picker: "seconds",
        ref: d
      })] }),
      r === ke && /* @__PURE__ */ n("div", {
        className: "lib:grid lib:gap-1 lib:text-center",
        children: /* @__PURE__ */ n(ne, {
          date: e,
          onDateChange: (N) => {
            t?.(N), N && N?.getHours() >= _ ? p("PM") : p("AM");
          },
          onLeftFocus: () => d?.current?.focus(),
          period: a,
          ref: g,
          setPeriod: p
        })
      })
    ]
  });
});
le.displayName = "TimePicker";
var et = m.forwardRef(({ locale: e = E, defaultPopupValue: t = new Date((/* @__PURE__ */ new Date()).setHours(f, f, f, f)), value: r, onChange: l, onMonthChange: i, hourCycle: u = B, disabled: b = !1, displayFormat: d, granularity: g = "day", placeholder: a = "Выберите дату", className: p, noPortal: N = !1, "data-testid": v, ...R }, P) => {
  const [o, h] = m.useState(r ?? t), T = ge(null), [S, y] = m.useState(r ?? void 0);
  i ||= l, m.useEffect(() => {
    y(r);
  }, [r]);
  const V = (c) => {
    if (!c) return;
    if (!t) {
      c.setHours(o?.getHours() ?? f, o?.getMinutes() ?? f, o?.getSeconds() ?? f), i?.(c), h(c);
      return;
    }
    const A = (c.getTime() - t.getTime()) / (Ce * Oe * Ve * Ye), L = pe(t, { days: Math.ceil(A) });
    L.setHours(o?.getHours() ?? f, o?.getMinutes() ?? f, o?.getSeconds() ?? f), i?.(L), h(L);
  }, Y = (c) => {
    c && (l?.(c), h(c), y(c));
  };
  Z(P, () => ({
    ...T.current,
    value: S
  }), [S]);
  const s = {
    hour24: d?.hour24 ?? `PPP HH:mm${!g || g === "second" ? ":ss" : ""}`,
    hour12: d?.hour12 ?? `PP hh:mm${!g || g === "second" ? ":ss" : ""} b`,
    onlyHours: "d MMMM yyyy"
  }, H = E, x = () => S ? g === "day" ? J(S, s.onlyHours, { locale: H }) : J(S, u === 24 ? s.hour24 : s.hour12, { locale: H }) : /* @__PURE__ */ n("span", { children: a }), F = ({ children: c, ...A }) => N ? /* @__PURE__ */ n(ce, {
    ...A,
    children: c
  }) : /* @__PURE__ */ n(ae, {
    ...A,
    children: c
  });
  return /* @__PURE__ */ w(se, { children: [/* @__PURE__ */ n(ue, {
    asChild: !0,
    disabled: b,
    children: /* @__PURE__ */ w("button", {
      className: M("lib:inline-flex lib:w-full lib:min-w-[14rem] lib:items-center lib:border-input lib:border-b lib:bg-transparent lib:pt-5 lib:pr-1 lib:pb-2 lib:font-cygre lib:font-normal lib:text-base lib:text-dark-90 lib:tracking-wide lib:transition-colors lib:placeholder:text-dark-60 lib:focus-visible:outline-hidden lib:disabled:cursor-not-allowed lib:disabled:opacity-50", !S && "lib:text-muted-foreground", p),
      "data-testid": v,
      ref: T,
      children: [/* @__PURE__ */ n(be, { className: "lib:mr-2 lib:h-4 lib:w-4" }), x()]
    })
  }), /* @__PURE__ */ w(F, {
    className: "lib:p-0",
    children: [/* @__PURE__ */ n(ie, {
      locale: e,
      mode: "single",
      month: o,
      onMonthChange: V,
      onSelect: (c) => {
        c && (c.setHours(o?.getHours() ?? f, o?.getMinutes() ?? f, o?.getSeconds() ?? f), Y(c));
      },
      selected: S,
      ...R
    }), g !== "day" && /* @__PURE__ */ n("div", {
      className: "lib:border-border lib:border-t lib:p-3",
      children: /* @__PURE__ */ n(le, {
        date: o,
        granularity: g,
        hourCycle: u,
        onChange: (c) => {
          l?.(c), y(c), c && h(c);
        }
      })
    })]
  })] });
});
et.displayName = "DateTimePicker";
export {
  ie as Calendar,
  et as UiDateTimePicker,
  le as UiTimePicker,
  D as UiTimePickerInput
};
